import { getApiBaseUrl, getTenantSlugFromHostname } from './api';

function buildHeaders() {
  const headers = {
    'Content-Type': 'application/json',
  };

  const tenantSlug = getTenantSlugFromHostname();
  if (tenantSlug) {
    headers['X-Tenant-Slug'] = tenantSlug;
  }

  return headers;
}

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? await response.json().catch(() => ({}))
    : {};

  if (!response.ok) {
    const message = payload?.error || `Request failed (${response.status})`;
    const err = new Error(message);
    err.status = response.status;
    throw err;
  }

  return payload;
}

/** Check whether a listing is favorited by the current user. */
export async function checkFavorite(listingId) {
  const response = await fetch(`${getApiBaseUrl()}/api/favorites/${encodeURIComponent(listingId)}`, {
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
  });

  return parseResponse(response);
}

/** Add a listing to favorites. */
export async function addFavorite(listingId) {
  const response = await fetch(`${getApiBaseUrl()}/api/favorites/${encodeURIComponent(listingId)}`, {
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
  });

  return parseResponse(response);
}

/** Remove a listing from favorites. */
export async function removeFavorite(listingId) {
  const response = await fetch(`${getApiBaseUrl()}/api/favorites/${encodeURIComponent(listingId)}`, {
    method: 'DELETE',
    headers: buildHeaders(),
    credentials: 'include',
  });

  return parseResponse(response);
}

/** Fetch all favorites for the current user in the current tenant. */
export async function fetchFavorites() {
  const response = await fetch(`${getApiBaseUrl()}/api/favorites`, {
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
  });

  return parseResponse(response);
}
